import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  NavController
} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private navCtrl: NavController,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

    pushRootPage(page, navData = null) {
      return new Promise(resolve => {
        navData ? this.navCtrl.navigateRoot(page, {state: navData}).then(() => {
          return resolve(true);
        }).catch((e) => {
          console.log('ePage', e);
          return resolve(false);
        }) : this.navCtrl.navigateRoot(page).then(() => {
          return resolve(true);
        }).catch((e) => {
          console.log('ePage', e);
          return resolve(false);
        });
      });
    }
    pushPage(page, navData = null) {
      console.log('pp',page,navData)
      return new Promise(resolve => {
        navData ? this.navCtrl.navigateForward(page, {state: navData}).then(() => {
          return resolve(true);
        }).catch((e) => {
          console.log('ePage1', e);
          return resolve(false);
        }) : this.navCtrl.navigateForward(page).then(() => {
          return resolve(true);
        }).catch((e) => {
          console.log('ePage2', e);
          return resolve(false);
        });
      });
    }
    popPage() {
      return new Promise(resolve => {
        this.navCtrl.pop().then(() => {
          return resolve(true);
        }).catch((e) => {
          return resolve(false);
        });
      });
    }
    navParams() {
      return new Promise(resolve => {
        this.activatedRoute.queryParams.subscribe(async () => {
        try {
          const routParams = this.router.getCurrentNavigation().extras.state || null;
          return resolve(routParams);
        } catch (e) {
          return resolve(undefined);
        }
      });
    });
  }
}
